module.exports = __webpack_public_path__ + "static/media/mail.8d343556.svg";